export const userViewsQuizAbandonerMenu = (petCount, furthestStep, bucket) => ({
  type: '[Quiz Return Menu] View Menu',
  data: {
    pets_in_cart: petCount,
    abandoned_step: furthestStep,
    audience_group: getAudienceGroup(bucket),
  },
});

export const userClicksQuizAbandonerMenuCTA = (buttonCopy, buttonType) => ({
  type: `[Quiz Return Menu] CTA Click`,
  data: {
    CTA_copy: buttonCopy,
    CTA_type: buttonType,
  },
});

const getAudienceGroup = bucket => {
  let map = {
    beforeMealPrep: 'Abandon Quiz',
    afterMealPrep: 'Abandon Meal Prep',
    atCheckout: 'Abandon Checkout',
  };

  return map[bucket];
};
